import NextImage from 'next/image'
import Link from 'next/link'
import { cn } from '@nwwp/ui-shadcn'
import { getPartnerSlug, type Partner } from '~/utils/partners-info'

type PartnerCardProps = {
  partner: Partner
  className?: string
}

export const PartnerCard = ({ partner, className }: PartnerCardProps) => (
  <div
    data-partner-card
    className={cn(
      'flex flex-col items-center overflow-hidden',
      'rounded-[20px] border border-frost bg-white shadow-card',
      'px-3 py-4 tablet:px-6',
      className
    )}
  >
    {/* Figma: 166px tall image in a 221px card (173px inner). On mobile keep that ratio so narrow grid cards shrink. */}
    <div className="relative aspect-[173/166] w-full max-w-[185px] tablet:aspect-auto tablet:h-[166px]">
      {/* Card exports are already 2x webp (~347×332, ~20KB); Next's optimizer re-encodes them at q75 and blurs them. */}
      <NextImage
        src={partner.imageUrl}
        alt={partner.name}
        fill
        unoptimized
        sizes="185px"
        className="object-contain object-top"
      />
    </div>
    <div className="flex w-full flex-col items-center text-center">
      {/* Typography on the link itself: an inline span inside would inherit the body line-height strut. */}
      <Link
        href={`/meet-your-partners/${getPartnerSlug(partner.name)}`}
        data-partner-name
        className="text-label-bold text-black underline underline-offset-4"
      >
        {partner.name}
      </Link>
      {/* Keep the credential line when empty so every card matches Figma's fixed 237px height. */}
      <span className="text-label text-charcoal">{partner.credential ?? '\u00a0'}</span>
    </div>
  </div>
)
